
class  BFileOpen {

    constructor() {
        this.isCef = window.hasOwnProperty("cefQuery");

        this.HfileSaveEv=this.fileSaveEv.bind(this);
        this.HfileOpenEv=this.fileOpenEv.bind(this);
		this.HfileOpenMultipleEv=this.fileOpenMultipleEv.bind(this);
        this.HfileOpenFolderEv=this.fileOpenFolderEv.bind(this);
    }

    send_message(test, params) {
        var message = 'DialogTest.' + test;
        if (typeof params != 'undefined')  message += ':' + params; 
        window.cefQuery({
			request : message, 
			onSuccess: function(response) {  },
            onFailure: function(error_code, error_message) {} 
		});
    }

    fileSave() {
        this.send_message('FileSave');
    }

    fileOpen() {
        this.send_message('FileOpen');
    }
	
    fileOpenMultiple() {
        this.send_message('FileOpenMultiple');
    }
 
	fileOpenFolder() {
        //this.send_message('FileOpenFolder');
        window.show_file_dialog('FileOpenFolder');
    }
	
    fileOpenEv(evt){
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOpen();
        return false;
    }

    fileSaveEv(evt){
        evt.preventDefault();
        evt.stopPropagation();
        this.fileSave();
        return false;
    }

    fileOpenMultipleEv(evt){
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOpenMultiple();
        return false;
    }

    fileOpenFolderEv(evt){
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOpenFolder();
        return false;
    }
}

export default BFileOpen;